import {formPostFet, getCargosExtHerFet, getCargosFet, getExternFet,    getColegios, getCargosInSchool, getCargosExtHerColegio,formPostColes} from "./fet";
import {formPostFundeo, getCargosExtHerFundeo, getCargosFundeo, getExternFundeo} from "./fundeo";

import {formPostMta, getCargosExtHerMta, getCargosMTA, getExternMta,    getPaises, getCargosPaises, getCargosExtHerPaises, formPostPaises, getMisionLocalHermanas} from "./mta";

export const MTAConfig = {
    familia: "MTA",
    extra: "paises",
    extra2: "hermanas",
    name: "Movimiento Teresiano Apostólico",
    logo: "logoMTA.png",
    fetchExternos: getExternMta,
    fetchCargos: getCargosMTA,
    fetchDisponibles: getCargosExtHerMta,
    post: formPostMta,

    fetchPaises: getPaises,
    fetchCargosPaises: getCargosPaises,
    fetchDisponiblesPaises: getCargosExtHerPaises,
    postPais: formPostPaises,

    urlAddExterno: "/familia/mta/addexterno",
    tabs: [
        {
            name: "MTA",
            fields: [
                {
                    name: "Directora general",
                    charges: ["Directora"]
                },
                {
                    name: "Equipos continental Europa",
                    charges: ["Coordinadora de mesa", "Miembros de la mesa", "Miembros de otros paises", "Delegada continental", "Delegada general"]
                },
                {
                    name: "Equipos continental America",
                    charges: ["Coordinadora de mesa", "Miembros de la mesa", "Miembros de otros paises", "Delegada continental", "Delegada general"]
                },
                {
                    name: "Equipos continental Africa",
                    charges: ["Coordinadora de mesa", "Miembros de la mesa", "Miembros de otros paises", "Delegada continental", "Delegada general"]
                },
            ]
        }
    ],

    paises: [
        {
            name: "Equipos Nacionales",
            fields: [
                {
                    name: "Componentes del equipo",
                    charges: ["Coordinación", "Vicecoordinación", "Secretaría", "Tesorería", "Representante del equipo continental", "Otros miembros", "Hermana Delegada Nacional"],
                },
            ]
        },
    ],    
}

export const FetConfig = {
    familia: "FET",
    extra: "coles",
    extra2: "",
    name: "Fundación Escuela Teresiana",
    logo: "logoFET.png",
    fetchExternos: getExternFet,
    fetchCargos: getCargosFet,
    fetchDisponibles: getCargosExtHerFet,
    post: formPostFet,

    fetchColegios: getColegios,
    fetchCargosSchool: getCargosInSchool,
    fetchDisponiblesColegio: getCargosExtHerColegio,
    postCole: formPostColes,

    urlAddExterno: "/familia/fet/addexterno",
    tabs: [
        {
            name: "Órgano de gobierno",
            fields: [
                {
                    name: "Patronato",
                    charges: ["Presidenta", "Vicepresidenta", "Secretaria", "Vocales"],
                },
                {
                    name: "Comisión permanente",
                    charges: ["Presidenta", "Miembros patronato"]
                }
            ]
        },
        {
            name: "Órgano de dirección",
            fields: [
                {
                    name: "Equipo titularidad",
                    charges: ["Director/a general", "Director/a pastoral", "Director/a pedagógica", "Director/a administrativo/a"],
                },
                {
                    name: "Equipo permanente area",
                    charges: ["Pastoral", "Pedagógico", "Formación", "Administración"],
                },
                {
                    name: "Servicios centrales",
                    charges: ["Comunicación", "Secretaria de Dirección general", "Apoyo area de Administración y Formación", "Servicio de Gestión Laboral para centros", "Recursos humanos y personal"],
                },
            ]
        }

    ],

    coles: [
        {
            name: "Colegios",
            fields: [
                {
                    name: "Equipo directivo del colegio",
                    charges: ["Director/a general", "Director/a pedagógico de educación infantil-primaria", "Director/a pedagógico de educación secundaria", "Coordinador/a ciclos formativos", "Coordinador/a de pastoral", "Administrador/a"],
                },
                {
                    name: "Hermanas que trabajan en el colegio",
                    charges: ['Administración', 'Docencia','Equipo de pastoral', 'Equipo de innovación', 'Mantenimiento',  'Orientación', 'Otros cargos','Secretaría', 'Servicios escolares'],
                }
            ]
        },

    ]
}

export const FundeoConfig = {
    familia: "FUNDEO",
    extra: "",
    extra2: "",
    name: "Fundación Enrique Osso",
    logo: "logoFUNDEO.png",
    fetchExternos: getExternFundeo,
    fetchCargos: getCargosFundeo,
    fetchDisponibles: getCargosExtHerFundeo,
    post: formPostFundeo,
    urlAddExterno: "/familia/fundeo/addexterno",
    tabs: [
        {
            name: "FUNDEO",
            fields: [
                {
                    name: "Patronato",
                    charges: ["Presidenta", "Vicepresidenta", "Secretaria", "Vocales"],
                },
                {
                    name: "Sede central",
                    charges: ["Dirección general", "Área técnica"],
                },
                {
                    name: "Delegaciones",
                    charges: ["Andalucía", "Aragón", "Canarias", "Castilla León", "Cataluña", "La Rioja", "Navarra", "Valencia"],
                },
                {
                    name: "Comisión de proyectos",
                    charges: ["Comisionados"],
                },
                {
                    name: "Comisión de voluntarios",
                    charges: ["Comisionados"],
                },
                {
                    name: "Comisión de gestión",
                    charges: ["Comisionados"],
                },
            ]
        }
    ],
}

